import {
    SetupDraftBrandsCampaign,
    CreateDraftBrandsCampaignValues,
    DraftBrandsCampaign,
    PublishedBrandsCampaign,
} from './types';
import { privateApi } from '../ApiService/PrivateApi';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { Period } from 'lib/types/period';

const fetchBrandsCampaign = async (brandsCampaignId: string): Promise<PublishedBrandsCampaign | DraftBrandsCampaign> =>
    privateApi.get<PublishedBrandsCampaign | DraftBrandsCampaign>(`brands-campaigns/${brandsCampaignId}`);

const fetchBrandsCampaigns = async (phaseId: string): Promise<(PublishedBrandsCampaign | DraftBrandsCampaign)[]> =>
    privateApi.get<(PublishedBrandsCampaign | DraftBrandsCampaign)[]>(`brands-phases/${phaseId}/campaigns`);

const createDraftBrandsCampaign = async (draftFields: CreateDraftBrandsCampaignValues): Promise<void> => {
    return privateApi.post('draft-brands-campaigns', draftFields);
};

const setupDraftBrandsCampaign = async (
    draftBrandsCampaignId: string,
    draftFields: SetupDraftBrandsCampaign,
): Promise<void> => {
    return privateApi.put(`draft-brands-campaigns/${draftBrandsCampaignId}`, draftFields);
};

const deleteDraftBrandsCampaign = async (draftBrandsCampaignId: string): Promise<void> => {
    return privateApi.delete(`draft-brands-campaigns/${draftBrandsCampaignId}`);
};

const publishDraftBrandsCampaign = async (draftBrandsCampaignId: string): Promise<PublishedBrandsCampaign> => {
    return privateApi.post(`draft-brands-campaigns/${draftBrandsCampaignId}/publish`);
};

const setupDraftBrandsCampaignTitle = async (draftBrandsCampaignId: string, title: string): Promise<void> => {
    return privateApi.put(`draft-brands-campaigns/${draftBrandsCampaignId}/title`, { title });
};

const setupDraftBrandsCampaignPeriod = async (
    draftBrandsCampaignId: string,
    data: { period: Period },
): Promise<void> => {
    return privateApi.put(`draft-brands-campaigns/${draftBrandsCampaignId}/period`, data);
};

export const BrandsCampaignGateway = {
    fetchBrandsCampaign,
    fetchBrandsCampaigns,
    createDraftBrandsCampaign,
    setupDraftBrandsCampaign,
    deleteDraftBrandsCampaign,
    publishDraftBrandsCampaign,
    setupDraftBrandsCampaignTitle,
    setupDraftBrandsCampaignPeriod,
};

const cancelableFetchBrandsCampaign = async (
    brandsCampaignId: string,
): Promise<PublishedBrandsCampaign | DraftBrandsCampaign> =>
    privateApiWithRouteLeavingCancelation.get<PublishedBrandsCampaign | DraftBrandsCampaign>(
        `brands-campaigns/${brandsCampaignId}`,
    );

const cancelableFetchBrandsCampaigns = async (
    phaseId: string,
): Promise<(PublishedBrandsCampaign | DraftBrandsCampaign)[]> =>
    privateApiWithRouteLeavingCancelation.get<(PublishedBrandsCampaign | DraftBrandsCampaign)[]>(
        `brands-phases/${phaseId}/campaigns`,
    );

export const CancelableBrandsCampaignGateway = {
    cancelableFetchBrandsCampaign,
    cancelableFetchBrandsCampaigns,
};
